import {Component} from "@angular/core";
import {LoginService} from "@app/login/login.service";
import {EmailValidator, FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {AlertsService} from "@app/utilities/alerts.service";

@Component({
    selector: 'flex-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css']
})
export class UserComponent {
    emailForm = new FormGroup({
        newEmail: new FormControl("", [Validators.email]),
        confirmEmail: new FormControl("", [Validators.email])
    }, this.emailMatchValidator)

    passwordForm = new FormGroup({
        currentPassword: new FormControl(""),
        newPassword: new FormControl(""),
        confirmPassword: new FormControl("")
    }, this.passwordMatchValidator)

    constructor(public loginService: LoginService, private http: HttpClient, private router: Router, public snackBar: AlertsService) {

    }

    passwordMatchValidator(g: FormGroup) {
        return g.get('newPassword').value === g.get('confirmPassword').value
            ? null : {'mismatch': true};
    }

    emailMatchValidator(g: FormGroup) {
        return g.get('newEmail').value === g.get('confirmEmail').value
            ? null : {'mismatch': true};
    }

    save() {
        if (!(this.emailForm.controls.newEmail.value === "") && !(this.emailForm.controls.confirmEmail.value === "")) {
            if (this.emailForm.valid) {
                const newEmail: EditEmailModel = {
                    username: this.loginService.activeUser.username.toUpperCase(),
                    email: this.emailForm.controls.newEmail.value
                }
                this.editEmail(newEmail);
            }
            else{
                this.snackBar.getError("Error: New email and Confirm email don't match.", 'X')
            }
        }
        if (!(this.passwordForm.controls.currentPassword.value === "") && !(this.passwordForm.controls.newPassword.value === "") &&
            !(this.passwordForm.controls.confirmPassword.value === "")) {
            if (this.passwordForm.valid) {
                const newPassword: EditPasswordModel = {
                    username: this.loginService.activeUser.username.toUpperCase(),
                    currPassword: this.passwordForm.controls.currentPassword.value,
                    newPassword: this.passwordForm.controls.newPassword.value
                }
                this.editPassword(newPassword)
            }
            else{
                this.snackBar.getError("Error: New password and Confirm password don't match.", 'X')
            }
        }
    }

    cancel() {
        this.router.navigate(['/news']);
    }

    editPassword(newPassword: EditPasswordModel){
        this.http.post('/api/secured/portalUser/editPassword', newPassword).subscribe((res:{status:string}) => {
                this.snackBar.getAlert(res.status, 'X')
                if(res.status === "Password Changed"){
                    this.router.navigate(['/news']);
                }
            },
            error => {
                this.snackBar.getError('Error: ' + error.status + ' ' + error.statusText, 'X')
            })
    }

    editEmail(newEmail: EditEmailModel){
        this.http.post('/api/secured/portalUser/editEmail', newEmail).subscribe(() => {
                this.snackBar.getAlert('Email Changed', 'X')
                this.router.navigate(['/news']);

            },
            error => {
                this.snackBar.getError('Error: ' + error.status + ' ' + error.statusText, 'X')
            })
    }
}

export class EditPasswordModel {
    username: string;
    currPassword: string;
    newPassword: string;
}

export class EditEmailModel {
    username: string;
    email: string;
}
